import $ from 'cash-dom';

// ------------------------------------------------------
//  Mobile Nav
// ------------------------------------------------------

$(function() {
  const body = $('body');
  const button = $('.burger-menu');
  const mobileNav = $('.mobile-nav');

  button.on('click', function (e) {
    e.preventDefault();
    body.toggleClass('no-scroll');
    button.toggleClass('burger-menu-active');
    mobileNav.toggleClass('mobile-nav-active');
  });
});
